import { DEFAULT_RENDER_SETTINGS } from '../constants'
import { threeDStudioStore } from '../index'

/**
 * Resets all render settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    renderSettings: { ...DEFAULT_RENDER_SETTINGS },
  })
}
